import { render, staticRenderFns } from "./RegionDash.vue?vue&type=template&id=47f3ca86&scoped=true&"
import script from "./RegionDash.vue?vue&type=script&lang=js&"
export * from "./RegionDash.vue?vue&type=script&lang=js&"
import style0 from "./RegionDash.vue?vue&type=style&index=0&id=47f3ca86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f3ca86",
  null
  
)

export default component.exports